export class SaasEntityProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "googleWorkspaceUser",
            "baseName": "googleWorkspaceUser",
            "type": "SaasGoogleWorkspaceUserProperties",
            "format": ""
        },
        {
            "name": "microsoft365User",
            "baseName": "microsoft365User",
            "type": "SaasMicrosoft365UserProperties",
            "format": ""
        },
        {
            "name": "group",
            "baseName": "group",
            "type": "SaasGroupProperties",
            "format": ""
        },
        {
            "name": "sharedDrive",
            "baseName": "sharedDrive",
            "type": "any",
            "format": ""
        },
        {
            "name": "sharePointSite",
            "baseName": "sharePointSite",
            "type": "any",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasEntityProperties.attributeTypeMap;
    }
    constructor() {
    }
}
